import React, { useEffect, useState } from 'react';
import '../Styles/Cart.css';
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { deleteAddress, getAddress, setDefaultAddress } from '../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import { AiTwotoneDelete } from "react-icons/ai";

const ManagePage = () => {
    const token = useSelector((state) => state.user.token);
    const user_id = useSelector((state) => state.user.userId);
    const [address, setAddress] = useState([]);
    const location = useLocation();
    const navigation = useNavigate();
    const { data } = location.state || {}; 

    //console.log("Data : ", data);

    const handleAddress = () => {
        //console.log("data manage : ", data)
        navigation('/search-location', { state: { data } });
    };

    useEffect(() => {
        const fetchAddress = async () => {
            const formData = new FormData();
            formData.append("token", token);
            formData.append("user_id", user_id);

            for (let pair of formData.entries()) {
                //console.log(`${pair[0]}: ${pair[1]}`);
            }

            try {
                const response = await getAddress(formData);
                //console.log("Address details: ", response);
                setAddress(response);
            } catch (error) {
                console.error("Error fetching restaurant details:", error);
            }
        };
        fetchAddress();
    }, [token, user_id]);

    const handleDelete = async (id) => {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("user_id", user_id);
        formData.append("address_id", id);

        for (let pair of formData.entries()) {
            //console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await deleteAddress(formData);
            //console.log("Address delete: ", response);
            setAddress(response);
        } catch (error) {
            console.error("Error fetching restaurant details:", error);
        }
    };

    const handleDefaultAddress = async (id) => {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("user_id", user_id);
        formData.append("address_id", id);

        for (let pair of formData.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await setDefaultAddress(formData);
            console.log("Default Address : ", response);
            if(response.status === 200){
                navigation("/")
            }
        } catch (error) {
            console.error("Error fetching restaurant details:", error);
        }
    };


    return (
        <div style={{
            padding: "0px 20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100vh",
        }}>
            <div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "770px",
                        margin: "auto"
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FaAngleLeft onClick={() => navigation(-1)} />
                        <p style={{ marginLeft: "23px" }}>MANAGE ADDRESS</p>
                    </div>
                    <div style={{ display: "flex", gap: "20px", marginRight: "13px" }}>
                        <Link to="/"><SlHome /></Link>
                    </div>
                </div>

                <div>
                    {address.map((adre) => (
                        <div style={{ width: "100%", position: "relative",marginBottom:"14px"}} key={adre.id} onClick={()=>{handleDefaultAddress(adre.id)}}>
                            <div className="address-option">
                                {adre.tag && (
                                    <p style={{
                                        margin: "0px", fontWeight: "bold", fontSize: "15px",
                                        textTransform: "uppercase"
                                    }}>{adre.tag}</p>
                                )}
                                {adre.house && <p style={{ margin: "0px" }}>{adre.house}</p>}
                                {adre.address && <p>{adre.address}</p>}
                            </div>
                            {data?.default_address_id === adre.id ? (
                                <span style={{
                                    position: "absolute", top: "24px", right: "2px",
                                    color: "orangered", fontWeight: "bold", fontSize: "20px",
                                }}>(✓)</span>
                            ) : (
                                <button style={{
                                    position: "absolute", top: "24px", right: "2px",
                                    border: "none", outline: "none", fontSize: "20px",
                                }}>
                                    <AiTwotoneDelete onClick={()=>{handleDelete(adre.id)}}/>
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <button onClick={handleAddress} style={{
                backgroundColor: "orangered", color: "white", borderRadius: "7px",
                outline: "none", border: "none", padding: "10px 0px",
            }}>NEW ADDRESS</button>
        </div>
    );
};

export default ManagePage;
